import { i18n } from '@/plugins/i18n'

export const stakeholderShopStatus = {
    CREATED:  1,
    ENABLED:  2,
    DISABLED: 3,
    REJECTED: 4,
}

export const stakeholderShopStatusStr = {
    CREATED:  i18n.t('stakeholder_shop_status.created'),
    ENABLED:  i18n.t('stakeholder_shop_status.enabled'),
    DISABLED: i18n.t('stakeholder_shop_status.disabled'),
    REJECTED: i18n.t('stakeholder_shop_status.rejected'),

    get(status) {
        let status_str = null;

        Object.keys(stakeholderShopStatus).forEach(function (item) {
            if(stakeholderShopStatus[item] === status) {
                status_str = stakeholderShopStatusStr[item];
            }
        })

        return status_str;
    }
}

export const stakeholderShopVariant = (status) => {
    if(status === stakeholderShopStatus.ENABLED) {
        return 'success';
    }

    if( status === stakeholderShopStatus.CREATED) {
        return 'warning';
    }

    if(status === stakeholderShopStatus.DISABLED || status === stakeholderShopStatus.REJECTED) {
        return 'danger';
    }

    return 'secondary';
}
